export default "__VITE_ASSET__BWq4YWb0__"